import axios from "axios";
import BASE_URL from ".";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

export const getAllUserAccountDetails = async () => {
  try {
    const res = await axios.get(BASE_URL + "/getAllUserAccountDetails", {
      Headers: {
        "Content-Type": "application/json",
      },
    });
    return res.data;
  } catch (error) {
    alert(error.toString());
  }
};

export const getUserAccountApproved = async (data) => {
  try {
    const res = await axios.post(BASE_URL + "/getUserAccountApproved", {
      Headers: {
        "Content-Type": "application/json",
      },
      data,
    });
    return res;
  } catch (error) {
    // A refusal - e.g. the email address is not confirmed yet - comes back
    // to the screen with its reason, instead of a raw browser alert.
    if (error.response) return error.response;
    alert(error.toString());
  }
};

export const getUserAccountbanned = async (data) => {
  try {
    const res = await axios.post(BASE_URL + "/getUserAccountbanned", {
      Headers: {
        "Content-Type": "application/json",
      },
      data,
    });
    return res;
  } catch (error) {
    // A refusal comes back to the screen with its reason.
    if (error.response) return error.response;
    alert(error.toString());
  }
};

export const getUserAccountUnbanned = async (data) => {
  try {
    const res = await axios.post(BASE_URL + "/getUserAccountUnbanned", {
      Headers: {
        "Content-Type": "application/json",
      },
      data,
    });
    return res;
  } catch (error) {
    alert(error.toString());
  }
};

export const getAllUserAccountRequestCount = async () => {
  try {
    const res = await axios.get(BASE_URL + "/getAllUserAccountRequestCount", {
      Headers: {
        "Content-Type": "application/json",
      },
    });
    return res.data;
  } catch (error) {
    alert(error.toString());
  }
};

export const getLastBackupInfo = async () => {
  try {
    const res = await axios.get(BASE_URL + "/recentBackup", {
      Headers: {
        "Content-Type": "application/json",
      },
    });
    return res.data;
  } catch (error) {
    alert(error.toString());
  }
};

export const makeBackup = async () => {
  // Deliberately not swallowing the error. Returning undefined on failure made
  // the caller overwrite the last-backup state with nothing, and dayjs(undefined)
  // renders as today - so a failed backup looked like a fresh one.
  const res = await axios.post(BASE_URL + "/newBackup", {
    Headers: {
      "Content-Type": "application/json",
    },
  });
  return res.data;
};

export const SignUpAPI = async (data) => {
  const {
    firstName,
    lastName,
    email,
    phoneNo,
    password,
    confirmPassword,
    rollSelect,
  } = data;

  const res = await axios.post(BASE_URL + "/Signup", {
    Headers: {
      "Content-Type": "application/json",
    },

    firstName: firstName,
    lastName: lastName,
    email: email,
    phoneNo: phoneNo,
    password: password,
    confirmPassword: confirmPassword,
    rollSelect: rollSelect,
  });
  return res
  // localStorage.setItem("res", JSON.stringify(res));
};
export const SignInWithGoogleDataAPI = async (data) => {
  const { firstName, lastName, email, rollSelect, phoneNo, googleToken } = data;

  const res = await axios.post(BASE_URL + "/signInWithGoogle", {
    Headers: {
      "Content-Type": "application/json",
    },
    firstName: firstName,
    lastName: lastName,
    email: email,
    phoneNo: phoneNo,
    rollSelect: rollSelect,
    googleToken,
  });
  return res
};

/**
 * Sign in with a Google access token. The server verifies it with Google and
 * returns { user, token } like password sign-in. A 404 with needsRegistration
 * means no account uses this address yet.
 *
 * Replaces checkExistEmail, which fetched any account's profile by address
 * from a public endpoint and never produced a session (QA finding AUTH-01).
 */
export const googleSignInAPI = async (googleToken) => {
  const res = await axios.post(BASE_URL + "/auth/google", { googleToken });
  return res.data;
};

export const GetSignInApi = async (data) => {
  const { email, password } = data;
  await axios
    .post(BASE_URL, {
      Headers: {
        "Content-Type": "application/json",
      },
      email: email,
      password: password,
    })
    .then((res) => {
      console.log(res);
      
      Cookies.set("currentUser", JSON.stringify(res.data.User), { expires: 7 });
      toast.success("Logged in successfully!");
    })
    .catch((err) => {
      if (err.response?.status === 404) {
        window.notify(err.response.data.message, "error");
      }
      Cookies.remove("currentUser");
    });
};

export const GetUserData = async () => {
  const user = JSON.parse(Cookies.get("currentUser"));
  const { email, password } = user;
  await axios
    .post(BASE_URL, {
      Headers: {
        "Content-Type": "application/json",
      },
      email: email,
      password: password,
    })
    .then((res) => {
      Cookies.remove("currentUser");
      Cookies.set("currentUser", JSON.stringify(res.data.User), { expires: 7 });
    });
};

/**
 * Forgot password, step 1: ask for a reset link to be emailed. The reply is
 * the same whether or not the address has an account. Throws with the
 * server's message on failure.
 */
export const requestPasswordReset = async (email) => {
  const res = await axios.post(BASE_URL + "/password-reset/request", { email });
  return res.data;
};

/** Confirm the email address given at sign-up, using the emailed link. */
export const confirmEmailAPI = async (token) => {
  const res = await axios.post(BASE_URL + "/email-verification/confirm", { token });
  return res.data;
};

/** Email a new confirmation link. Same reply whether or not the address has an account. */
export const resendConfirmationAPI = async (email) => {
  const res = await axios.post(BASE_URL + "/email-verification/resend", { email });
  return res.data;
};

/** Forgot password, step 2: set the new password using the emailed link. */
export const confirmPasswordReset = async ({ token, newPassword }) => {
  const res = await axios.post(BASE_URL + "/password-reset/confirm", { token, newPassword });
  return res.data;
};

/**
 * Change the signed-in user's password.
 *
 * This previously destructured `data.password`, which the caller never set, so
 * every request sent `password: undefined` and no email. The endpoint now
 * identifies the account from the session token and requires the current
 * password as proof of ownership.
 */
export const newPass = async ({ currentPassword, newPassword }) => {
  const res = await axios.put(BASE_URL + "/ResetPassword", {
    currentPassword,
    newPassword,
  });
  return res.data;
};




/**
 * An administrator edits another member of staff, including their role.
 * Kept separate from the self-service profile update, which only ever edits
 * the signed-in user's own record.
 */
export const adminUpdateUserAPI = async (userDetails) => {
  const res = await axios.post(`${BASE_URL}/admin/update-user`, userDetails);
  return res.data;
};

export const updateUserDataAPI = async (userData) => {
  try {
    const res = await axios.post(`${BASE_URL}/update-userInfo`, userData);
    toast.success("Details Updated Successfully!");
    return res.data.updatedUser; // Return the response data
  } catch (error) {
    toast.error("Error in updating Details");
    throw error; // Ensure the error is propagated to the mutation's `onError` handler
  }
};

/** Connect Google Calendar with the code from Google's pop-up. */
export const updateUserG = async ({ code }) => {
  try {
    const res = await axios.post(`${BASE_URL}/update-userInfoG`, { code });
    // Upcoming shoots they were already assigned to are added on connecting.
    const { added = 0, failed = 0 } = res.data.calendar || {};
    const shoots = (n) => `${n} upcoming shoot${n === 1 ? "" : "s"}`;
    toast.success(added > 0
      ? `Google Calendar connected - ${shoots(added)} added to your calendar.`
      : "Google Calendar connected!");
    if (failed > 0) toast.warning(`${shoots(failed)} could not be added. They will be retried the next time a manager saves the team.`);
    return res.data.updatedUser;
  } catch (error) {
    toast.error(error?.response?.data?.message || "Could not connect Google Calendar. Please try again.");
    throw error;
  }
};


export const updateUserData = async (userData) => {
  try {
    await axios
      .post(BASE_URL + "/update-userInfo", userData)
      .then(async (res) => {
        
        toast.success("Details Updated Successfully!");
        return res.data.updatedUser
      })
      .catch((err) => {
        console.log(err);
      });
  } catch (error) {
    toast.error("Error in updating Details");
  }
};

export const getAllUsers = async () => {
  try {
    const res = await axios.get(BASE_URL + "/getAllUsers", {
      Headers: {
        "Content-Type": "application/json",
      },
    });
    return res.data;
  } catch (error) {
    alert(error.toString());
  }
};

export const getUsersExcludingShooters = async () => {
  try {
    const res = await axios.get(BASE_URL + "/getUsersExcludingShooters", {
      Headers: {
        "Content-Type": "application/json",
      },
    });
    return res.data;
  } catch (error) {
    alert(error.toString());
  }
};

export const getEditors = async () => {
  try {
    const res = await axios.get(BASE_URL + "/getEditors", {
      Headers: {
        "Content-Type": "application/json",
      },
    });
    return res.data;
  } catch (error) {
    alert(error.toString());
  }
};
export const getShooters = async () => {
  try {
    const res = await axios.get(BASE_URL + "/getShooters", {
      Headers: {
        "Content-Type": "application/json",
      },
    });
    return res.data;
  } catch (error) {
    alert(error.toString());
  }
};
